import type { Router } from 'next/router';

import {
    getBedsMax,
    getBedsMin,
    getPropertyType,
    getPropertySubType,
    getNewHomes,
    getIsRetirementHome,
    getIsSharedOwnership,
    getIsAuction,
    getFeatures,
    getDuration,
    getPriceFrequency,
    getPriceMax,
    getPriceMin,
    getQ,
    getRadius,
    getTransportType,
    getResultsSort,
    getAdded,
    getChainFree,
    getIncludeSold,
    getReducedPriceOnly,
    getIsSharedAccommodation,
    getBillsIncluded,
    getPetsAllowed,
    getFurnishedState,
    getAvailableFrom,
    getIncludeRented,
    getKeywords
} from '.';

export const getFormValuesFromQuery = ({
    query,
    pathname
}: Pick<Router, 'query' | 'pathname'>) => {
    const formValues = {
        added: getAdded(query),
        available_from: getAvailableFrom(query),
        beds_max: getBedsMax(query),
        beds_min: getBedsMin(query),
        bills_included: getBillsIncluded(query),
        chain_free: getChainFree(query),
        duration: getDuration(query),
        feature: getFeatures(query),
        furnished_state: getFurnishedState(query),
        include_rented: getIncludeRented(query),
        include_sold: getIncludeSold(query),
        is_auction: getIsAuction(query, pathname),
        is_retirement_home: getIsRetirementHome(query),
        is_shared_accommodation: getIsSharedAccommodation(query),
        is_shared_ownership: getIsSharedOwnership(query),
        keywords: getKeywords(query),
        new_homes: getNewHomes(query, pathname),
        pets_allowed: getPetsAllowed(query),
        price_frequency: getPriceFrequency(query),
        price_max: getPriceMax(query),
        price_min: getPriceMin(query),
        property_sub_type: getPropertySubType(query),
        property_type: getPropertyType(query),
        q: getQ(query),
        radius: getRadius(query),
        reduced_price_only: getReducedPriceOnly(query),
        results_sort: getResultsSort(query),
        transport_type: getTransportType(query)
    };

    return formValues;
};

export type FormValues = ReturnType<typeof getFormValuesFromQuery>;
